import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../components/Logo';
import Icon from '../components/Icon';
import Seo from '../components/Seo';
import { BrokenSignal } from '../components/illustrations';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Seo title="Sayfa bulunamadı" noindex />
      <div style={{ padding: 'var(--sp-5)' }}>
        <Logo />
      </div>
      <div
        className="page-enter"
        style={{ flex: 1, display: 'grid', placeItems: 'center', textAlign: 'center', padding: 'var(--sp-6)' }}
      >
        <div>
          <BrokenSignal />
          <h1 style={{ fontSize: '1.8rem', margin: 'var(--sp-4) 0 var(--sp-2)' }}>{t('notfound.title')}</h1>
          <p style={{ color: 'var(--text-3)', maxWidth: '24rem', margin: '0 auto var(--sp-5)' }}>{t('notfound.desc')}</p>
          <Link to="/" className="btn">
            <Icon name="arrow" size={14} style={{ transform: 'rotate(180deg)' }} />
            {t('notfound.back_home')}
          </Link>
        </div>
      </div>
    </div>
  );
}
